"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabBehavior = void 0;
var TabBehavior;
(function (TabBehavior) {
    TabBehavior["All"] = "all";
    TabBehavior["InitialOnly"] = "initialOnly";
    TabBehavior["FirstInView"] = "firstInView";
    TabBehavior["LastInView"] = "lastInView";
})(TabBehavior || (exports.TabBehavior = TabBehavior = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFiQmVoYXZpb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdHlwZXMvdGFiQmVoYXZpb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBRTVELElBQVksV0FLWDtBQUxELFdBQVksV0FBVztJQUNuQiwwQkFBVyxDQUFBO0lBQ1gsMENBQTJCLENBQUE7SUFDM0IsMENBQTJCLENBQUE7SUFDM0Isd0NBQXlCLENBQUE7QUFDN0IsQ0FBQyxFQUxXLFdBQVcsMkJBQVgsV0FBVyxRQUt0QiJ9